import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** プログレス表示アクションクリエータ */
export const initialize = actionCreator('INITIALIZE');



// WEBPACK FOOTER //
// ./src/actions/root.ts